import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Figure from './figure';
import { fetchLayerData } from '@actions/layers-actions';

const Layers = ({ list, name, next }) => {
  const dispatch = useDispatch();
  const layers = useSelector(state => state.layers);
  const prevNextRef = useRef(next);

  // Initial fetch on mount if list is empty
  useEffect(() => {
    if (!layers[name].list.length) {
      dispatch(fetchLayerData(name));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch more data when next changes (pagination)
  useEffect(() => {
    if (!layers[name].loadingComplete && next && prevNextRef.current !== next) {
      dispatch(fetchLayerData(name));
    }
    prevNextRef.current = next;
  }, [next, layers, name, dispatch]);

  return list.map(layer => <Figure key={layer.id} layer={layer} name={name} />);
};

Layers.propTypes = {
  id: PropTypes.number,
  list: PropTypes.array,
  name: PropTypes.string,
  next: PropTypes.string
};

export default Layers;
